export default __webpack_public_path__ + "static/media/ic_create.9f2864e3.svg";